/**
 * @desc 根据id查询角色
 */
import { RoleDetail } from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryRoleParameter = {
  id?: string
}

const method = 'GET'
const url = '/auth/role'

export const queryRoleApi = (
  params?: QueryRoleParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<RoleDetail>({
    method,
    url,
    params,
    ...config
  })
}

queryRoleApi.method = method
queryRoleApi.url = url
